// @ts-expect-error Untyped module
import Cookies from 'js-cookie'; // todo move this function to cookieUtils and delete the file.

export const hasAcceptedCookies = () => Cookies.get('__hs_cookie_cat_pref') === '1:true,2:true,3:true' || Cookies.get('__hs_opt_out') === 'no' || false;